'use strict';

var React = require('react');

var SvgAccessibilityMajor = function SvgAccessibilityMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.779 9.165c-.221.453-.279.753-.279.835 0 .082.058.382.279.835.21.427.533.925.983 1.398.89.937 2.264 1.767 4.238 1.767a.75.75 0 0 1 0 1.5c-2.444 0-4.196-1.045-5.325-2.233a7.204 7.204 0 0 1-1.243-1.773c-.26-.532-.432-1.076-.432-1.494 0-.418.171-.962.432-1.494a7.205 7.205 0 0 1 1.243-1.773c1.13-1.188 2.88-2.233 5.325-2.233 2.432 0 4.12.972 5.224 2.1 1.083 1.107 1.6 2.355 1.754 2.968a.75.75 0 0 1-1.456.364c-.096-.387-.495-1.389-1.37-2.282-.853-.872-2.166-1.65-4.152-1.65-1.974 0-3.348.83-4.238 1.767-.45.472-.774.971-.983 1.398Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.28 12.78a.75.75 0 1 0-1.06-1.06l-2.97 2.97-1.22-1.22a.75.75 0 1 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l3.5-3.5Z"
  }));
};
SvgAccessibilityMajor.displayName = "AccessibilityMajor";

exports.SvgAccessibilityMajor = SvgAccessibilityMajor;
